module.exports = __webpack_public_path__ + "static/media/bot.min.8f0189f4.svg";